import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useProduct } from "../store/product";

import l10n from "../lib/l10n";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import BizLogo from "./BizLogo";
import { useAppDialog } from "../store/app-dialog";
import CroppedCanvas from "./Cropper/CroppedCanvas";
import { checkoutActions } from "../store/checkout";

export const CheckoutSuccessDialog = ({ action }) => {
  const product = useProduct((s) => s.product);
  const {closeDialog} = useAppDialog();
  switch (action) {
    case checkoutActions.CHECKOUT_ACTION_BUY_NOW:
      return (
        <>
          <DialogContent>
            <Typography mb={2}>
              {l10n.ui_dialog_action_buy_now_text}
              <strong>{product.name}</strong>
            </Typography>
            <CroppedCanvas />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              color="success"
              variant="contained"
              href={l10n.url_checkout.toString()}
              startIcon={<ShoppingCartCheckoutIcon />}>
              {l10n.ui_dialog_action_buy_now_cta}
            </Button>
          </DialogActions>
        </>
      );
    case checkoutActions.CHECKOUT_ACTION_ADD_TO_CART:
      return (
        <>
          <DialogContent>
            <Typography mb={2}>
              <strong>{product.name}</strong> {l10n.ui_dialog_action_add_to_cart_text}
            </Typography>
            <CroppedCanvas />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              color="success"
              variant="contained"
              href={l10n.url_cart.toString()}
              startIcon={<ShoppingCartCheckoutIcon />}>
              {l10n.ui_dialog_action_add_to_cart_cta}
            </Button>
          </DialogActions>
        </>
      );
    case checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE:
      return (
        <>
          <DialogContent>
            {/* <CroppedCanvas /> */}
            <BizLogo />
            <Typography
              dangerouslySetInnerHTML={{
                __html: l10n.ui_dialog_action_quote_text,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="outlined"
              onClick={closeDialog}
            >
              Chiudi
            </Button>
          </DialogActions>
        </>
      );
    case checkoutActions.CHECKOUT_ACTION_CREATE_ORDER:
      return (
        <>
          <DialogContent>
            {/* <CroppedCanvas /> */}
            <BizLogo />
            <Typography
              dangerouslySetInnerHTML={{
                __html: l10n.ui_dialog_action_order_text,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="outlined"
              onClick={closeDialog}
            >
              Chiudi
            </Button>
          </DialogActions>
        </>
      );
    default:
      // no action defined 
      break;
  }
};
